import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField } from '@mui/material';

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
  InputLabelProps: PropTypes.object,
};

export default function RHFTextField({ name, type, InputLabelProps, ...other }) {
  const { control } = useFormContext();

  // A file input always paints its "Choose File" button, so an unshrunk floating
  // label would sit on top of it. Keep the label shrunk for those.
  const labelProps = type === 'file' ? { shrink: true, ...InputLabelProps } : InputLabelProps;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          type={type}
          InputLabelProps={labelProps}
          error={!!error}
          helperText={error?.message}
          {...other}
        />
      )}
    />
  );
}
